export type LoggedOutStateValues = {
  loggedOut: boolean;
};

export interface ILoggedOutState {
  values: LoggedOutStateValues;
  updateValues: (newValues: Partial<LoggedOutStateValues>) => void;
  registerObserver: (observer: () => void) => void;
  unregisterObserver: (observer: () => void) => void;
}

export class LoggedOutState implements ILoggedOutState {
  private observers: ((values: LoggedOutStateValues) => void)[];

  public values: LoggedOutStateValues;

  constructor(_values?: LoggedOutStateValues) {
    this.values = _values || {
      loggedOut: false, // Defaults to false
    };
    this.observers = [];
  }

  public updateValues(newValues: Partial<LoggedOutStateValues>) {
    this.values = {...this.values, ...newValues};
    // eslint-disable-next-line no-restricted-syntax
    for (const observer of this.observers) {
      observer(this.values);
    }
  }

  public registerObserver(observer: () => void) {
    this.observers.push(observer);
  }

  public unregisterObserver(observer: () => void) {
    this.observers = this.observers.filter((o) => o !== observer);
  }
}
